/* Avis clients de la fiche produit (13/10/2026, version validée : « oui c'est très bien comme ça »).
   - Fiche avec avis (section da-avis-judgeme, [data-da-avis]) : les avis viennent de l'API publique du widget Judge.me,
     celle que le widget appelle lui-même (30 avis par appel). Résumé chiffré, bande de toutes les photos, carrousel des
     12 avis les plus utiles (note, puis photo, puis avis détaillé, puis récent : critère écrit dans la ligne grise, comme
     l'exige l'art. D111-17 du code de la consommation). Un avis touché s'ouvre dans la fenêtre du thème, comme le guide
     des pointures ; « Tout voir » montre toutes les photos ; « Voir les N avis » déplie la liste complète de Judge.me
     (classée par date, avec « Écrire un avis »). Si l'API ne répond pas, la liste de Judge.me s'affiche d'office.
   - Fiche sans avis ([data-da-vitrine]) : sélection fixe choisie avec l'utilisateur (8 avis pour les fiches femme, 6 pour
     les fiches homme). Chaque carte nomme son modèle, en texte, sans lien : le maillage ne bouge pas. Les avis sont dans
     ce fichier (en cache) plutôt que dans la page : le même texte n'est pas répété dans le HTML de 57 fiches.
   Rien n'est demandé à Judge.me avant que la section approche de l'écran. */
(() => {
  'use strict';
  const API = 'https://api.judge.me/reviews/reviews_for_widget';
  const BOUTIQUE = 'jx0v3b-ij.myshopify.com';
  const NS = 'http://www.w3.org/2000/svg';
  const CROIX = 'M480-437.85 277.08-234.92q-8.31 8.3-20.89 8.5-12.57.19-21.27-8.5-8.69-8.7-8.69-21.08 0-12.38 8.69-21.08L437.85-480 234.92-682.92q-8.3-8.31-8.5-20.89-.19-12.57 8.5-21.27 8.7-8.69 21.08-8.69 12.38 0 21.08 8.69L480-522.15l202.92-202.93q8.31-8.3 20.89-8.5 12.57-.19 21.27 8.5 8.69 8.7 8.69 21.08 0 12.38-8.69 21.08L522.15-480l202.93 202.92q8.3 8.31 8.5 20.89.19 12.57-8.5 21.27-8.7 8.69-21.08 8.69-12.38 0-21.08-8.69L480-437.85Z';
  const DANS_CARROUSEL = 12;

  /* VITRINE-DEBUT (généré par SEO-SEA/avis-v3/construire_vitrine.py, ne pas modifier à la main) */
  const VITRINE = {"femme":[{"note":5,"texte":"Tout simplement super ! Tellement doux et confortable, la taille 36 convient parfaitement à un pied de 22,7 cm, avec un peu d'espace pour une chaussette.","nom":"Anonyme","date":"12/09/2026","tri":"2026-09-11T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675526__0__Wtc2Pbew__S5108b7dc30f94d8bbac2d8bbfba9e8e4k__original.jpeg?quality=80&width=1024"],"modele":{"nom":"Mocassin indien femme en daim à lacet","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-indien-daim-femme-vue-d-ensemble.webp?v=1790311385&width=80"}},{"note":5,"texte":"Excellente qualité du cuir. Convient aux pieds fins.","nom":"U***M","date":"15/02/2026","tri":"2026-02-14T23:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675455__0__Jk4p72CP__A764a6872b8364321b9595da11ee6ae93P__original.jpg?quality=80&width=1024"],"modele":{"nom":"Loafer femme en cuir à mors","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/loafers-femme-vue-d-ensemble.webp?v=1790142525&width=80"}},{"note":5,"texte":"Les chaussures sont de très haute qualité, magnifiques et s'adaptent parfaitement à un pied de 24 cm en taille 38. Fortement recommandées !","nom":"Anonyme","date":"04/10/2026","tri":"2026-10-03T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675500__0__iIEXslNA__S4ff2563ea17e43088d2b0a189e0d88081__original.jpeg?quality=80&width=1024"],"modele":{"nom":"Mocassin femme luxe en cuir à chaîne","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-femme-luxe-vue-d-ensemble.webp?v=1791508990&width=80"}},{"note":5,"texte":"Je les adore, ils taillent parfaitement, ils sentent le cuir et ils sont vraiment adorables. Je les adore. Je les adore. Je les adore. Je les rachèterai, mais je ne veux que la couleur rose et je les ai déjà.","nom":"D***s","date":"07/05/2026","tri":"2026-05-06T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675559__0__phC951Ae__Adb732cdaf605494c902404537630e6daa__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin ajouré femme en cuir à gland","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassins-ajoures-femme-vue-d-ensemble.webp?v=1790894943&width=80"}},{"note":5,"texte":"Exactement comme sur la photo ! Doux, belle couleur, ils ont l'air élégants ! Oui, ils sont très plats !","nom":"l***r","date":"30/11/2025","tri":"2025-11-29T23:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675408__0__qwnCm-yo__A62c0f8a1eef94ed2b058e493ab207d5bn__original.jpg?quality=80&width=1024"],"modele":{"nom":"Ballerine léopard pour femme","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/ballerine-leopard-vue-d-ensemble.webp?v=1791508010&width=80"}},{"note":5,"texte":"Très haute qualité et confortable, j'ai pris une demi-pointure au-dessus.","nom":"H***r","date":"17/11/2025","tri":"2025-11-16T23:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675433__0__8hi1B4Wq__Acf63d3f5be274aeb9c8a9a65c0b78afc4__original.jpg?quality=80&width=1024"],"modele":{"nom":"Chaussure bateau femme marron","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/chaussure-bateau-femme-marron-vue-d-ensemble.webp?v=1790311218&width=80"}},{"note":5,"texte":"Magnifique ! Le guide des tailles est précis, le tissu est doux, confortable et beau.","nom":"Anonyme","date":"26/05/2026","tri":"2026-05-25T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675499__0__m2gnO37U__A27358a7ea3ff4045ab5fadacc54f37f7u__original.jpeg?quality=80&width=1024"],"modele":{"nom":"Mocassin femme grande taille en daim","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-femme-grande-taille-vue-d-ensemble.webp?v=1790214375&width=80"}},{"note":5,"texte":"Ma femme les a adorés, ils sont vraiment magnifiques 😍","nom":"Anonyme","date":"30/05/2026","tri":"2026-05-29T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675413__0__qMNHqyMC__Aba4af8cef0f74fa692d30c0d9bfb175aZ__original.jpg?quality=80&width=1024"],"modele":{"nom":"Ballerine confortable en maille à bride","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/ballerines-confortables-vue-d-ensemble.webp?v=1790311027&width=80"}}],"homme":[{"note":5,"texte":"J'achète toujours ce type de chaussures. Fortement recommandé.","nom":"Anonyme","date":"20/04/2026","tri":"2026-04-19T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675456__0__7GXPZKcc__A1504aa1c66644b4c99df55944fb42e8ev__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin à lacet homme semelle à picots","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-a-lacet-homme-vue-d-ensemble.webp?v=1790142112&width=80"}},{"note":5,"texte":"Du solide, aussi beau que sur la photo.","nom":"a***r","date":"24/02/2026","tri":"2026-02-23T23:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675456__0__fEIrIt7E__A41cc0c62272d4cbda4f90503ce615365U__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin à pampilles homme en cuir tressé","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-a-pampilles-vue-d-ensemble.webp?v=1790969599&width=80"}},{"note":5,"texte":"Je suis très content des chaussures. Ils sont de bonne qualité, je les aime beaucoup. Je recommande fortement de les acheter.","nom":"P***A","date":"23/07/2026","tri":"2026-07-22T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675495__0__jOUHOOMR__Add690c61515843dc962dea0ffcac95b4B__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin espadrille homme en daim","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-espadrille-homme-vue-d-ensemble.webp?v=1790142502&width=80"}},{"note":5,"texte":"Très bon produit, je recommande le vendeur","nom":"y***i","date":"06/11/2025","tri":"2025-11-05T23:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675532__0__84wdHKV___A7c3dda59cb704892927ff0f7e39f8199Z__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin plat homme en cuir de vache","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-plat-homme-vue-d-ensemble.webp?v=1790969473&width=80"}},{"note":5,"texte":"taille parfaite.. très bonne qualité","nom":"Anonyme","date":"28/04/2026","tri":"2026-04-27T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675527__0__x1VQikYH__Aa35848036a6b41de9ad96446642b4f8bB__original.jpg?quality=80&width=1024"],"modele":{"nom":"Mocassin loafer homme en cuir","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/mocassin-loafer-homme-vue-d-ensemble.webp?v=1790142156&width=80"}},{"note":5,"texte":"Les chaussures sont comme annoncées. J'ai suivi les conseils de quelqu'un d'autre et j'ai commandé une taille plus grande que ce que je ferais normalement. Je fais habituellement du 43 mais j'ai pris du 44. S'adapte parfaitement aux chaussettes invisibles.","nom":"Anonyme","date":"14/07/2026","tri":"2026-07-13T22:00:00.000Z","verifie":false,"photos":["https://review-images.judgeme.com/mocassin-avenue/1791675566__0__5eQ7HQIr__A92867fc124f1447daaf2f8e274f59823Y__original.jpg?quality=80&width=1024"],"modele":{"nom":"Penny loafers homme en suédine","image":"https://cdn.shopify.com/s/files/1/1079/1151/2394/files/penny-loafers-homme-vue-d-ensemble.webp?v=1790214134&width=80"}}]};
  /* VITRINE-FIN */

  const el = (tag, attrs = {}, enfants = []) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (v == null || v === false) continue;
      if (k === 'texte') n.textContent = v;
      else if (k === 'classe') n.className = v;
      else n.setAttribute(k, v === true ? '' : v);
    }
    for (const e of [].concat(enfants)) if (e != null) n.append(e);
    return n;
  };
  const icone = (d, taille = 25) => {
    const s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 -960 960 960');
    s.setAttribute('width', taille);
    s.setAttribute('height', taille);
    s.setAttribute('class', 'da-icone');
    s.setAttribute('aria-hidden', 'true');
    const p = document.createElementNS(NS, 'path');
    p.setAttribute('d', d);
    p.setAttribute('fill', 'currentColor');
    s.append(p);
    return s;
  };
  const photo = (url, largeur) => (url ? url.replace(/width=\d+/, `width=${largeur}`) : null);
  const dateFr = (iso) => {
    const d = new Date(String(iso || '').replace(' UTC', 'Z').replace(' ', 'T'));
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris' });
  };
  // Le texte des avis arrive en HTML : on n'en garde que le texte, paragraphe par paragraphe (rien n'est injecté).
  const texteDe = (html) => {
    const d = new DOMParser().parseFromString(html || '', 'text/html');
    const ps = [...d.querySelectorAll('p')].map((p) => p.textContent.trim()).filter(Boolean);
    return ps.length ? ps.join('\n') : d.body.textContent.trim();
  };
  const etoiles = (note) => {
    const n = Math.max(0, Math.min(5, Math.round(Number(note) || 0)));
    return el('span', { classe: 'da-avis3__etoiles', role: 'img', 'aria-label': `${n} étoile${n > 1 ? 's' : ''} sur 5` }, [
      document.createTextNode('★'.repeat(n)),
      el('span', { classe: 'da-avis3__vides', 'aria-hidden': 'true', texte: '★'.repeat(5 - n) }),
    ]);
  };
  const lire = (a) => ({
    note: Number(a.rating) || 0,
    // 19/10 : les notes importées sans commentaire portent un caractère invisible (Judge.me exige un texte)
    texte: texteDe(a.body_html).replace(/[\u200b\u2060\ufeff]/g, '').trim(),
    nom: a.reviewer_name || 'Anonyme',
    date: dateFr(a.created_at),
    tri: String(a.created_at || ''),
    verifie: !!a.verified_buyer,
    photos: (a.pictures_urls || []).map((p) => p.original || p.huge || p.compact || p.small).filter(Boolean),
  });
  // Le critère annoncé sous le résumé (19/10, sa demande) : avec photo, puis avec commentaire, puis sans
  // commentaire ; dans chaque groupe, les mieux notés, puis les plus détaillés, puis les plus récents.
  const plusUtile = (x, y) => ((y.photos.length ? 1 : 0) - (x.photos.length ? 1 : 0))
    || ((y.texte ? 1 : 0) - (x.texte ? 1 : 0))
    || (y.note - x.note)
    || (Math.min(y.texte.length, 300) - Math.min(x.texte.length, 300))
    || (y.tri > x.tri ? 1 : y.tri < x.tri ? -1 : 0);

  /* ---------- Carte d'un avis (carrousel) ---------- */
  const modeleDe = (m) => (m ? el('span', { classe: 'da-avis3__modele' }, [
    m.image ? el('img', { src: m.image, alt: '', loading: 'lazy', width: 30, height: 30 }) : null,
    el('span', { texte: m.nom }),
  ]) : null);
  const carte = (a, i) => el('button', { type: 'button', classe: 'da-avis3__carte', 'data-i': i }, [
    a.photos[0] ? el('img', { src: photo(a.photos[0], 480), alt: '', loading: 'lazy', width: 480, height: 480 }) : null,
    el('span', { classe: 'da-avis3__corps' }, [
      etoiles(a.note),
      a.texte
        ? el('span', { classe: 'da-avis3__texte', texte: a.texte })
        : el('span', { classe: 'da-avis3__texte da-avis3__texte--vide', texte: 'Note sans commentaire' }),
      el('span', { classe: 'da-avis3__qui', texte: `${a.nom} · ${a.date}${a.verifie ? ' · Achat vérifié' : ''}` }),
      modeleDe(a.modele),
    ]),
  ]);

  /* ---------- Fenêtre (classes du thème : la même que le guide des pointures) ---------- */
  let fenetre = null;
  const laFenetre = () => {
    if (fenetre) return fenetre;
    const titre = el('p', { classe: 'da-dialogue__titre', id: 'da-avis3-titre' });
    const fermer = el('button', { type: 'button', classe: 'da-dialogue__fermer', 'aria-label': 'Fermer' }, [icone(CROIX)]);
    const corps = el('div', { classe: 'da-dialogue__corps' });
    fenetre = el('dialog', { classe: 'da-dialogue da-dialogue--centre da-avis3-fenetre', 'aria-labelledby': 'da-avis3-titre' }, [
      el('div', { classe: 'da-dialogue__boite', tabindex: '-1' }, [el('div', { classe: 'da-dialogue__entete' }, [titre, fermer]), corps]),
    ]);
    fermer.addEventListener('click', () => fenetre.close());
    fenetre.addEventListener('click', (e) => { if (e.target === fenetre) fenetre.close(); });
    fenetre.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' && fenetre.daSuivant) fenetre.daSuivant();
      if (e.key === 'ArrowLeft' && fenetre.daPrecedent) fenetre.daPrecedent();
    });
    fenetre.daTitre = titre;
    fenetre.daCorps = corps;
    document.body.append(fenetre);
    return fenetre;
  };
  const ouvrir = (titre, contenu) => {
    const f = laFenetre();
    f.daTitre.textContent = titre;
    // Un morceau absent (null) ne doit pas s'écrire « null » : replaceChildren le prendrait pour du texte
    f.daCorps.replaceChildren(...[].concat(contenu).filter((x) => x != null));
    f.daCorps.scrollTop = 0;
    f.daPrecedent = null;
    f.daSuivant = null;
    if (!f.open) f.showModal();
    return f;
  };
  const fleche = (sens, libelle, actif, action) => {
    const b = el('button', { type: 'button', classe: 'da-avis3__fleche', 'aria-label': libelle, disabled: !actif, texte: sens });
    b.addEventListener('click', action);
    return b;
  };
  const ouvrirAvis = (liste, i) => {
    const a = liste[i];
    const contenu = [el('div', { classe: 'da-avis3-ouvert' }, [
      a.photos[0] ? el('img', { classe: 'da-avis3-ouvert__photo', src: photo(a.photos[0], 1024), alt: `Photo de ${a.nom}` }) : null,
      a.photos.length > 1 ? el('div', { classe: 'da-avis3-ouvert__autres' }, a.photos.slice(1).map((u) => el('img', { src: photo(u, 480), alt: `Photo de ${a.nom}`, loading: 'lazy' }))) : null,
      etoiles(a.note),
      a.texte
        ? el('p', { classe: 'da-avis3-ouvert__texte', texte: a.texte })
        : el('p', { classe: 'da-avis3-ouvert__texte da-avis3__texte--vide', texte: 'Note sans commentaire' }),
      el('p', { classe: 'da-avis3__qui', texte: `${a.nom} · ${a.date}${a.verifie ? ' · Achat vérifié' : ''}` }),
      modeleDe(a.modele),
      el('div', { classe: 'da-avis3-ouvert__pied' }, [
        el('span', { texte: `${i + 1} / ${liste.length}` }),
        el('span', { classe: 'da-avis3__fleches' }, [
          fleche('‹', 'Avis précédent', i > 0, () => ouvrirAvis(liste, i - 1)),
          fleche('›', 'Avis suivant', i < liste.length - 1, () => ouvrirAvis(liste, i + 1)),
        ]),
      ]),
    ])];
    const f = ouvrir('Avis client', contenu);
    f.daPrecedent = i > 0 ? () => ouvrirAvis(liste, i - 1) : null;
    f.daSuivant = i < liste.length - 1 ? () => ouvrirAvis(liste, i + 1) : null;
  };
  const ouvrirPhotos = (photos, liste) => {
    const grille = el('div', { classe: 'da-avis3-grille' }, photos.map(({ url, i }) => {
      const b = el('button', { type: 'button', 'aria-label': `Voir l'avis de ${liste[i].nom}` }, [el('img', { src: photo(url, 240), alt: '', loading: 'lazy', width: 240, height: 240 })]);
      b.addEventListener('click', () => ouvrirAvis(liste, i));
      return b;
    }));
    ouvrir(`Leurs photos (${photos.length})`, grille);
  };
  const ouvrirExplication = (vitrine) => ouvrir('Nos avis', [
    el('p', { texte: vitrine
      ? "Ces avis ont été déposés par des acheteurs de nos modèles sur une autre plateforme de vente. Nous en montrons une sélection, parmi les mieux notés ; chaque avis indique le modèle concerné."
      : "Ces avis ont été déposés par des acheteurs de ce modèle sur une autre plateforme de vente." }),
    el('p', { texte: "Nous les relisons avant publication : nous écartons ceux qui sont illisibles, en double ou qui ne parlent pas du modèle, ainsi que les photos qui ne le montrent pas. Jamais un avis parce qu'il est négatif. Les notes laissées sans commentaire sont gardées et signalées comme telles." }),
    vitrine ? null : el('p', { texte: "Sous le résumé, les avis avec photo s'affichent en premier, puis ceux avec un commentaire, puis les notes sans commentaire ; dans chaque groupe, les mieux notés et les plus détaillés d'abord. La liste complète (« Voir tous les avis ») les classe du plus récent au plus ancien." }),
    el('p', { texte: "La date indiquée est celle de l'avis." }),
  ]);

  /* ---------- Carrousel : flèches et barre de progression ---------- */
  const brancherRail = (rail, nav) => {
    if (!rail || !nav) return;
    const progres = nav.querySelector('[data-da-progres]');
    const [prec, suiv] = nav.querySelectorAll('button');
    const pas = () => {
      const c = rail.querySelector('.da-avis3__carte');
      return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 12) : rail.clientWidth;
    };
    const maj = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 2;
      const part = Math.max(rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1, 0.08);
      if (progres) {
        progres.style.width = `${part * 100}%`;
        progres.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * (1 / part - 1) * 100 : 0}%)`;
      }
      if (prec) prec.disabled = rail.scrollLeft <= 2;
      if (suiv) suiv.disabled = rail.scrollLeft >= max - 2;
    };
    prec?.addEventListener('click', () => rail.scrollBy({ left: -pas(), behavior: 'smooth' }));
    suiv?.addEventListener('click', () => rail.scrollBy({ left: pas(), behavior: 'smooth' }));
    rail.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    new ResizeObserver(maj).observe(rail);
    maj();
  };

  /* ---------- Fiche avec avis ---------- */
  const unePage = (id, n) => fetch(`${API}?url=${BOUTIQUE}&shop_domain=${BOUTIQUE}&platform=shopify&product_id=${id}&page=${n}&per_page=30`, { credentials: 'omit' })
    .then((r) => { if (!r.ok) throw new Error(`Judge.me ${r.status}`); return r.json(); });
  const montrerListe = (racine, ouverte) => {
    const liste = racine.querySelector('[data-da-liste]');
    const bouton = racine.querySelector('[data-da-tout]');
    if (!liste) return;
    liste.hidden = !ouverte;
    if (bouton) {
      bouton.setAttribute('aria-expanded', String(ouverte));
      bouton.textContent = ouverte ? 'Réduire les avis' : bouton.dataset.texte;
    }
    if (ouverte) window.dispatchEvent(new Event('resize'));
  };
  const initAvis = async (racine) => {
    const bouton = racine.querySelector('[data-da-tout]');
    if (bouton) {
      bouton.dataset.texte = bouton.textContent.trim();
      bouton.addEventListener('click', () => {
        const ouvrirListe = racine.querySelector('[data-da-liste]').hidden;
        montrerListe(racine, ouvrirListe);
        if (ouvrirListe) racine.querySelector('[data-da-liste]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    racine.querySelector('[data-da-savoir]')?.addEventListener('click', () => ouvrirExplication(false));
    let premiere;
    let liste;
    try {
      premiere = await unePage(racine.dataset.daAvis, 1);
      const pages = Math.min(Number(premiere.pagination && premiere.pagination.total_pages) || 1, 10);
      const autres = await Promise.all(Array.from({ length: pages - 1 }, (_, k) => unePage(racine.dataset.daAvis, k + 2)));
      liste = [premiere, ...autres].flatMap((r) => (r && r.reviews) || []).map(lire).sort(plusUtile);
    } catch (e) {
      // Judge.me ne répond pas : la liste complète de son widget reste le plan B
      racine.classList.add('da-avis3--sans-api');
      montrerListe(racine, true);
      return;
    }
    if (!liste.length) {
      montrerListe(racine, true);
      return;
    }
    // Répartition des notes
    const histo = premiere.histogram || [];
    racine.querySelectorAll('[data-da-repartition]').forEach((ligne) => {
      const n = Number(ligne.dataset.daRepartition);
      const x = histo.find((v) => Number(v.rating) === n) || { frequency: 0, percentage: 0 };
      const jauge = ligne.querySelector('i span');
      if (jauge) jauge.style.width = `${Number(x.percentage) || 0}%`;
      const compte = ligne.querySelector('[data-da-compte]');
      if (compte) compte.textContent = x.frequency;
    });
    // Origine : tant qu'aucun avis n'est vérifié, la ligne grise parle de l'autre plateforme ; sinon des deux
    const mention = racine.querySelector('[data-da-origine]');
    const verifies = liste.filter((a) => a.verifie).length;
    if (mention && verifies) {
      mention.textContent = verifies === liste.length ? 'Avis vérifiés de nos clients' : 'Avis vérifiés de nos clients et avis d\'acheteurs de ce modèle sur une autre plateforme de vente';
    }
    // Photos
    const photos = liste.flatMap((a, i) => a.photos.map((url) => ({ url, i })));
    const zone = racine.querySelector('[data-da-photos]');
    if (zone && photos.length) {
      zone.querySelector('[data-da-nb-photos]').textContent = photos.length;
      const bande = zone.querySelector('[data-da-bande]');
      bande.replaceChildren(...photos.map(({ url, i }) => {
        const b = el('button', { type: 'button', 'aria-label': `Voir l'avis de ${liste[i].nom}` }, [el('img', { src: photo(url, 240), alt: '', loading: 'lazy', width: 240, height: 240 })]);
        b.addEventListener('click', () => ouvrirAvis(liste, i));
        return b;
      }));
      zone.querySelector('[data-da-tout-voir]')?.addEventListener('click', () => ouvrirPhotos(photos, liste));
      zone.hidden = false;
    }
    // Carrousel des plus utiles ; la fenêtre parcourt ensuite tous les avis dans le même ordre
    const rail = racine.querySelector('[data-da-rail]');
    if (rail) {
      rail.replaceChildren(...liste.slice(0, DANS_CARROUSEL).map(carte));
      rail.addEventListener('click', (e) => {
        const b = e.target.closest('.da-avis3__carte');
        if (b) ouvrirAvis(liste, Number(b.dataset.i));
      });
      rail.hidden = false;
      brancherRail(rail, racine.querySelector('[data-da-nav]'));
    }
    marquerSansTexte(racine);
    racine.classList.add('da-avis3--pret');
  };

  /* ---------- Liste complète de Judge.me : notes sans commentaire (19/10) ---------- */
  const marquerSansTexte = (racine) => {
    const zone = racine.querySelector('[data-da-liste]');
    if (!zone) return;
    const marquer = () => zone.querySelectorAll('p, div, span').forEach((e) => {
      if (e.children.length === 0 && e.textContent.length && !e.textContent.replace(/[\u200b\u2060\ufeff\s]/g, '')
        && /[\u200b\u2060\ufeff]/.test(e.textContent)) e.classList.add('da-sans-texte');
    });
    marquer();
    new MutationObserver(marquer).observe(zone, { childList: true, subtree: true });
  };

  /* ---------- Fiche sans avis : la sélection ---------- */
  const initVitrine = (racine) => {
    const liste = VITRINE[racine.dataset.daVitrine] || VITRINE.femme || [];
    const rail = racine.querySelector('[data-da-rail]');
    if (!liste.length || !rail) {
      racine.hidden = true;
      return;
    }
    rail.replaceChildren(...liste.map(carte));
    rail.addEventListener('click', (e) => {
      const b = e.target.closest('.da-avis3__carte');
      if (b) ouvrirAvis(liste, Number(b.dataset.i));
    });
    racine.querySelector('[data-da-savoir]')?.addEventListener('click', () => ouvrirExplication(true));
    brancherRail(rail, racine.querySelector('[data-da-nav]'));
  };

  /* ---------- Démarrage : à l'approche de la section ---------- */
  const demarrer = (racine, init) => {
    if (racine.dataset.daAvisPret) return;
    racine.dataset.daAvisPret = '1';
    init(racine);
  };
  const tout = () => {
    const cibles = [...document.querySelectorAll('[data-da-avis]')].map((r) => [r, initAvis])
      .concat([...document.querySelectorAll('[data-da-vitrine]')].map((r) => [r, initVitrine]));
    if (!cibles.length) return;
    if (!('IntersectionObserver' in window)) {
      cibles.forEach(([r, f]) => demarrer(r, f));
      return;
    }
    const io = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        const c = cibles.find(([r]) => r === e.target);
        if (c) demarrer(c[0], c[1]);
      });
    }, { rootMargin: '900px 0px' });
    cibles.forEach(([r]) => io.observe(r));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
})();
